import { BaseOption } from './MultiSelectField.types';

export const SELECT_ALL_OPTION_VALUE = 'all';

export const isSelectAll = ({ value }: Partial<BaseOption>) =>
  value === SELECT_ALL_OPTION_VALUE;

export const isNotSelectAll = ({ value }: Partial<BaseOption>) =>
  value !== SELECT_ALL_OPTION_VALUE;

export const isValidOption = (
  option: Partial<BaseOption>,
): option is BaseOption => !!option;
